import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { DataService } from 'src/app/services/data/data.service';
import { DateService } from 'src/app/services/date/date.service';


@Component({
  selector: 'sale-history',
  templateUrl: './sale-history.component.html',
  styleUrls: ['./sale-history.component.scss'],
})
export class SaleHistoryComponent implements OnInit {
  @Input()
  tournee:TourneeModel;

  minDate = new Date();
  maxDate = new Date();


  parentTournee:TourneeModel;

  children:TourneeModel[] = []

  @Input()
  producer:ProfileModel;

  sorting = "date";

  sortingDirection = 'down';

  constructor(public route:ActivatedRoute, private dataService:DataService, private navParams: NavParams, 
    private navCtrl:NavController, private modalCtrl: ModalController, private dateService:DateService) {
    this.tournee = this.navParams.data.tournee;
    this.maxDate.setFullYear(new Date().getFullYear() + 1);
    this.dataService.getTourneeTemplateProducer(this.tournee.parentKey,this.tournee.producer.key)
      .pipe(take(1))
      .subscribe(result=>{
        console.log(result);
        this.parentTournee = result;

        this.parentTournee.details.nextDate = this.minDate = this.getLastDate(this.parentTournee.children);       

        const childrenÀrray = Object.entries(this.parentTournee.children);
        for(const child of childrenÀrray){
          this.dataService.getTourneeFinancesProducer(child[0],this.tournee.producer.key).pipe(take(1)).subscribe(result => {
            result.details = {
              date:this.parentTournee.children[child[0]].date
            };
            result.status = this.parentTournee.children[child[0]].status;
            this.children.push(result);
          })
        }
        this.children.sort((a,b)=> a.details.date > b.details.date && 1 || -1);
      })
  }

  ngOnInit() {
  }

  getLastDate(children:any){
    let array:any = Object.values(children)
    array = array.sort((a,b)=> a.date > b.date && 1 || -1)
    return array[array.length-1].date;
  }

  async onChildClicked(item:TourneeModel){
    this.navCtrl.navigateForward("/producer/" + this.tournee.producer.key + "/sale/" + item.key);
  }

  sortBy(type: string): void {
    if (type == "date") {
      if(this.sortingDirection == 'up'){
        this.children = this.children.sort((a, b) => {
          return a.details.date < b.details.date ? -1 : 0;
        });
        this.sortingDirection = 'down';        
      }
      else{
        this.children = this.children.sort((a, b) => {
          return a.details.date > b.details.date ? -1 : 0;
        });
        this.sortingDirection = 'up';
      }
      this.sorting = "date";
    } else {
      if(this.sortingDirection == 'up'){
        this.children = this.children.sort((a, b) => {
          const astats = a.finances ? a.finances.orderCount : 0;
          const bstats = b.finances ? b.finances.orderCount : 0;
          return bstats - astats;
        });
        this.sortingDirection = 'down';        
      }
      else{
        this.children = this.children.sort((a, b) => {
          const astats = a.finances ? a.finances.orderCount : 0;
          const bstats = b.finances ? b.finances.orderCount : 0;
          return astats-bstats;
        });
        this.sortingDirection = 'up'; 
      }
      this.sorting = "orderCount";
    }
  }
  
}
